import {
  DELETE_ITEM,
  LOAD_ITEMS,
  SORT_INTENT
} from "../../modules/savedItems/constants";
import {
  getSavedItemsAroundIndex,
  deleteSavedItem,
  changeSort
} from "../../modules/savedItems/actions";

const actionCreatorMap = {
  [DELETE_ITEM]: payload => deleteSavedItem(payload),
  [LOAD_ITEMS]: payload => getSavedItemsAroundIndex(payload),
  [SORT_INTENT]: payload => changeSort(payload)
};

export default (dispatch, { type, payload }) =>
  dispatch(actionCreatorMap[type](payload));
